import React from 'react';
import Hero from '../components/sections/Hero';
import Demographics from '../components/sections/Demographics';
import Features from '../components/sections/Features';
import Process from '../components/sections/Process';
import Pricing from '../components/sections/Pricing';
import Cta from '../components/sections/Cta';

const Home = () => {
  return (
    <>
      <Hero />
      <Demographics />
      <Features />
      <Process />
      <Pricing />
      <Cta />
    </>
  );
};

export default Home;